import { useEffect, useState } from 'react';
import styles from "./TrimSurfaces.module.css";

export default function TrimSurfaces({ handleSurfaceSelect }) {

    const [surfaces, setSurfaces] = useState([]);
    const [selectedSurface, setSelectedSurface] = useState(null); 

    useEffect(() => {
        const surfaceList = [];
        document.getElementById('chamViz').applyByFilter("", "", function (newSel, currentSelectedSurface) {
            if (this.type.toLowerCase().includes('trim')) {
                surfaceList.push({ key: this.sortorder, name: this.name });
            }
        });

        // Set the surfaces and select the first one
        if (surfaceList.length > 0) {
            setSurfaces(surfaceList);
            setSelectedSurface(surfaceList[0].name); 
            handleSurfaceSelect({ target: { name: 'surface-selector', value: surfaceList[0].name } }); 
        }
    }, []); 

    const handleChange = (e) => {
        setSelectedSurface(e.target.value); 
        handleSurfaceSelect(e);
    };

    return (
        <div className={styles.content}>
            <ul>
                {surfaces.length > 0 ? (
                    surfaces.map((surface) => (
                        <li key={surface.key}>
                            <label htmlFor={`surface-${surface.key}`}>{surface.name}</label>
                            <input
                                type="radio"
                                id={`surface-${surface.key}`}
                                name="surface-selector"
                                value={surface.name}
                                checked={selectedSurface === surface.name}
                                onChange={handleChange}
                            />
                        </li>
                    ))
                ) : (
                    <li>No surfaces</li>
                )}
            </ul>
        </div>
    );
}
